<template>
  <div class="meter-reading-index">
    <Echart ref="option" :options="option" style="height: 100%" />
  </div>
</template>

<script>
import { getAction } from '@/api/manage'

export default {
  name: 'MeterReadingIndex',
  data() {
    return {
      option: {},
      url: {
        meterIndex: "/jeecg-engineering/ticket/tickets/list"
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.getData()
    },
    
    getData() {
      getAction(this.url.meterIndex).then(res => {
        if (res.success) {
          this.setOption(res.result)
        } else {
          this.setOption(this.getMockData())
        }
      }).catch(() => {
        this.setOption(this.getMockData())
      })
    },
    
    getMockData() {
      return {
        weekDays: [this.$t('周一'), this.$t('周二'), this.$t('周三'), this.$t('周四'), this.$t('周五'), this.$t('周六'), this.$t('周日')],
        shouldRead: [134, 133, 122, 144, 314, 223, 414],
        actualRead: [134, 133, 122, 144, 314, 223, 414],
        readRate: [100, 100, 100, 100, 100, 100, 100]
      }
    },
    
    setOption(data) {
      const seriesData = []
      
      seriesData[0] = {
        name: this.$t('应抄'),
        type: 'bar',
        barMaxWidth: 14,
        stack: 'sum',
        smooth: true,
        symbol: "none",
        animationDelay: (0 * 200) - 100,
        animationDuration: 300,
        data: data.shouldRead || [134, 133, 122, 144, 314, 223, 414]
      }
      
      seriesData[1] = {
        name: this.$t('实抄'),
        type: 'bar',
        barMaxWidth: 14,
        stack: 'sum1',
        smooth: true,
        symbol: "none",
        animationDelay: (0 * 200) - 100,
        animationDuration: 300,
        data: data.actualRead || [134, 133, 122, 144, 314, 223, 414]
      }
      
      seriesData[2] = {
        name: this.$t('抄表率'),
        type: 'line',
        yAxisIndex: 1,
        symbol: 'circle',
        animationDelay: 1000,
        stack: 'Total',
        smooth: true,
        animationDuration: 300,
        data: data.readRate || [100, 100, 100, 100, 100, 100, 100]
      }

      this.option = {
        color: ['#0394FF', '#50E3C2', '#F6BB2F', '#0C2D82', '#B620E0', '#4634FA', '#F7B500', '#FA6400', '#E02020'],
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(4, 22, 44, 0.8)',
          borderColor: 'rgba(0, 168, 255, 0.5)',
          borderWidth: 1,
          borderRadius: 4,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#00a8ff'
            }
          }
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          itemHeight: 10,
          right: 0,
          top: 5
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: data.weekDays || [this.$t('周一'), this.$t('周二'), this.$t('周三'), this.$t('周四'), this.$t('周五'), this.$t('周六'), this.$t('周日')],
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: ['#074671'],
            }
          },
          axisLabel: {
            color: '#fff',
            fontSize: 12
          }
        },
        yAxis: [
          {
            type: 'value',
            name: this.$t('抄表(万户)'),
            nameTextStyle: {
              color: '#D1F3FF',
              align: 'center',
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: ['#074671'],
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#fff',
              fontSize: 12
            }
          },
          {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            name: this.$t('抄表率(%)'),
            nameTextStyle: {
              color: '#D1F3FF',
              align: 'center',
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dotted',
                color: ['#074671'],
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              formatter: '{value} %',
              color: '#D1F3FF',
              fontSize: 10
            }
          }
        ],
        series: seriesData
      }
    }
  }
}
</script>

<style lang="less" scoped>
.meter-reading-index {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.chart-container {
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 0;
}

@media (max-width: 1200px) {
  .meter-reading-index {
    padding: 0;
  }
}
</style>